import { Coupon, CouponDiscountType } from "@/generated/graphql_billing";
import { useMemo } from "react";
import { dateToString } from "@moneyforward/mfx_biz_react_components";
import { addMonths } from "date-fns";

type Props = {
  coupon: Coupon;
  from: Date;
};

export const couponDiscountPeriodText = ({ coupon, from }: Props) => {
  return useMemo(() => {
    let text = "";
    if (coupon) {
      switch (coupon.discountType) {
        case CouponDiscountType.Endless:
          text = "無期限";
          break;
        case CouponDiscountType.Absolute:
          text =
            dateToString(new Date(coupon.discountPeriodTo)).slice(0, 7) +
            "まで";
          break;
        case CouponDiscountType.Relative:
          // discountPeriodが1より小さい場合は非表示
          if (from && coupon.discountPeriod && coupon.discountPeriod > 0) {
            text =
              dateToString(
                addMonths(new Date(from), coupon.discountPeriod - 1)
              ).slice(0, 7) + "まで";
          }
          break;
        default:
          break;
      }
      return text;
    }
  }, [coupon, from]);
};
